export default __webpack_public_path__ + "whats-due-start-map-icon.fbb3e1ad.svg";